export const COLORS = {
  bg: "#09090f",
  surface: "rgba(255,255,255,0.03)",
  surfaceHover: "rgba(255,255,255,0.055)",
  surfaceHigh: "rgba(255,255,255,0.06)",
  surfaceLow: "rgba(255,255,255,0.02)",
  // Opaque equivalent of `surface` composited over `bg` — for a table/panel surface that must be
  // fully opaque (e.g. a frozen table column that would otherwise let scrolled content bleed
  // through) yet read as a soft elevated card rather than pure near-black `bg`.
  surfaceSolid: "#101017",
  border: "rgba(255,255,255,0.07)",
  borderHigh: "rgba(255,255,255,0.12)",
  brand: "#7c3aed",
  brandHover: "#6d28d9",
  brandSoft: "rgba(124,58,237,0.12)",
  brandText: "#c4b5fd",
  text: "#f1f5f9",
  textMuted: "#94a3b8",
  textDim: "#64748b",
  textFaint: "#475569",
  textGhost: "#334155",
  success: "#10b981",
  successBg: "rgba(16,185,129,0.1)",
  warning: "#f59e0b",
  warningBg: "rgba(245,158,11,0.1)",
  danger: "#ef4444",
  dangerBg: "rgba(239,68,68,0.1)",
  info: "#0ea5e9",
  infoBg: "rgba(14,165,233,0.1)",
  stageLead: "#94a3b8",
  stageQualified: "#0ea5e9",
  stageDiscovery: "#6366f1",
  stageValidation: "#7c3aed",
  stageCommercial: "#a855f7",
  stageClosedWon: "#10b981",
  stageClosedLost: "#475569",
  forecastCommit: "#10b981",
  forecastUpside: "#6366f1",
  forecastPipeline: "#f59e0b",
  forecastOmit: "#ef4444",
  customer: "#10b981",
  prospect: "#6366f1",
  churned: "#475569",
  partner: "#f59e0b",
  healthy: "#10b981",
  atRisk: "#f59e0b",
  critical: "#ef4444",
  commercial: "#6366f1",
  enterprise: "#7c3aed",
  strategic: "#f59e0b",
  white: "#ffffff",
  overlay: "rgba(0,0,0,0.6)",
} as const;
